import { NumericFormat } from "react-number-format"
type LabelType = 'Gross' | 'Net';

type PayVerticalTileProps = {
  totalPay: number;
  label: LabelType;
};

export const PayVerticalTile = ({totalPay,label}:PayVerticalTileProps) => {
    return <>
        <div className="small d-flex justify-content-center">
            {label=='Gross'&&<strong>{label}: &nbsp;</strong>}
            {label=='Net'&&<span>{label}: &nbsp;</span>}
            <NumericFormat
                thousandSeparator=","
                displayType="text"
                thousandsGroupStyle="thousand"
                decimalScale={2}
                fixedDecimalScale={true}
                prefix="$"
                value={isNaN(totalPay) || totalPay == null ? 0 : totalPay}
            />
        </div>
    </>
}